import { EntityId } from '../EntityId';

export interface UnitCarac {
  type: UnitCaracType;

  ground_adv?: string | null;
  ground_mar?: string | null;
  fly_adv?: string | null;
  fly_mar?: string | null;
  dis?: string | null;
  evoked: string | null;

  hp: string | null;
  def: string | null;
  res: string | null;
  arm: string | null;
  aeg: string | null;

  unitType: EntityId<number> | null;
  unitBase: EntityId<string>;
  unitHeight: EntityId<string>;
}

export enum UnitCaracType {
  V1 = 0,
  V2 = 1,
  V3 = 2,
}
